<template>
  <div>
    <p style="font-weight: bold; color: #df0303; font-size: 1.3rem">
      ATTENTION: Each of the three (3) tasks must be submitted individually to obtain marks for the
      exam.
    </p>

    <h2 class="mb-4">Introductory Information</h2>

    <v-simple-table>
      <thead>
        <tr>
          <td colspan="2" style="font-weight: bold; font-size: 1.13rem">
            Practical Lab Exam - 2025
          </td>
        </tr>
        <tr v-for="field in fields" :key="field">
          <td style="width: 220px">
            {{ field.name }}
          </td>
          <td>
            <v-text-field v-model="inputs[field.inputKey]" />
          </td>
        </tr>
      </thead>
    </v-simple-table>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'UOttawa1301ExamCover2025',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        author: null,
        demonstrator: null,
        date: null,
      },
      fields: [
        {name: 'Student Name: ', inputKey: 'author'},
        {name: "TA's (Demonstrator's) Name: ", inputKey: 'demonstrator'},
        {name: 'Date Experiment Performed: ', inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
